/**
 * @generated SignedSource<<087c5fbaec069d08876125a5254213b6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpRespPersonalizedItemsCarouselLazy_user$data = {
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPersonalizedItemsCarousel_user">;
  readonly " $fragmentType": "PdpRespPersonalizedItemsCarouselLazy_user";
};
export type PdpRespPersonalizedItemsCarouselLazy_user$key = {
  readonly " $data"?: PdpRespPersonalizedItemsCarouselLazy_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpRespPersonalizedItemsCarouselLazy_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isClient"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpRespPersonalizedItemsCarouselLazy_user",
  "selections": [
    {
      "condition": "isClient",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "PdpRespPersonalizedItemsCarousel_user"
        }
      ]
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "e964236b15b308f5120ec40c68b56ecb";

export default node;
